import CustomersVoice from 'components/CustomersVoice';
import {TopFAQ} from 'components/FAQ';
import Layout from 'components/Layout';
import Price from 'components/Price';
import FirstView from 'components/FirstView';
import SEO from 'components/seo';
import Design from 'components/Design';
import React from 'react';
import { PriceCatch, Features, IndustrySamples } from 'components/Introduction';

const ComachiPage = () => {
  return (
    <Layout>
      <SEO title='comachicart' />
      <FirstView/>
      <IndustrySamples />
      <Features />
      <PriceCatch />
      <Price />
      {/* TODO: お客様の声が追加されたら表示する
      <CustomersVoice />
      */}
      <Design />
      <TopFAQ />
    </Layout>
  );
};

export default ComachiPage;